import React from 'react'
import { Callout } from '../Callout'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { useUserFeedSocieties } from '../../../views/feed/useUserFeedSocieties'
import { isUserAdminInSociety } from '../../../helpers/society'
import { BlockedCallout } from '../../blocked/BlockedCallout'
import { useAuth } from '../../../hooks/useAuth'

export interface LockedSocietiesCallout {
  className?: string
}

export const LockedSocietiesCallout = ({
  className,
}: LockedSocietiesCallout): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { userId: authUserId } = useAuth()

  const userId = authUserId as string
  const { societies: societiesWhereUserCanPost } = useUserFeedSocieties({
    userId,
  })

  const lockedSocietiesForUser = societiesWhereUserCanPost.filter(
    (society) => isUserAdminInSociety(society, userId) && society.locked
  )
  // get Locked societies
  return (
    <div className="mb-3 flex flex-col gap-3">
      <div className={`flex flex-col gap-2 ${className ?? ''}`}>
        {lockedSocietiesForUser.map((society) => (
          <Callout
            key={society._id}
            text={translate('common.callout.namedSocietyLocked.title', {
              societyName: society.name,
            })}
            path={reverseUrl('management:billing-payment', {
              id: society._id,
            })}
            warning
          />
        ))}
      </div>
      <BlockedCallout />
    </div>
  )
}
